// extracted by mini-css-extract-plugin
module.exports = {"dialog":"CustomModal_dialog__3kyhm","sm":"CustomModal_sm__Uyzz-","lg":"CustomModal_lg__1BOs4"};